import {useAuth0} from "@auth0/auth0-react"
import React from "react"

import {Button} from "@/components/ui/button"

interface LoginProps {}

const Login: React.FC<LoginProps> = () => {
    const {loginWithRedirect} = useAuth0()

    return (
        <div className="h-screen flex flex-col">
            <div className="container mx-auto flex-1 flex justify-center items-center">
                <div className="w-full max-w-md p-8 space-y-6 bg-secondary text-secondary-foreground shadow-lg rounded-lg text-center">
                    <h1 className="text-3xl font-bold text-gray-700">Adviser Chatbot</h1>
                    <p className="text-gray-500">Please log in with your @futurenet.com account to continue</p>
                    <Button onClick={() => loginWithRedirect()} className="w-full py-3 bg-primary font-semibold">
                        Log In
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Login
